<template>
    <ams-slider ref="amsSliderRef" @after-scroll="onAfterScroll">
        <ams-list-item
            v-for="item of amsSearch.items"
            ref="itemsComponents"
            :key="item.externalId"
            :data-external-id="item.externalId"
            :for-location-name="amsSearch.request.locationName"
            has-dynamic-tooltip
            is-vertical
            :item="item"
            @click="onItemClick(item)"
        />
    </ams-slider>
</template>
<script lang="ts" setup>
import { AmsSearchResponse } from '../../../services/amsSearch/amsSearch.interface'
import AmsSlider from '../../../components/AmsSlider'
import AmsListItem from '../../../components/AmsListItem'
import { ref, toRef } from 'vue'
import { useTracking } from './useTracking'
import { useItemsIntersectionObserver } from '../../../composables/useItemsIntersectionObserver/useItemsIntersectionObserver'

const props = defineProps<{ amsSearch: AmsSearchResponse }>()

const amsSliderRef = ref<InstanceType<typeof AmsSlider>>()
const itemsComponents = ref<InstanceType<typeof AmsListItem>[]>()

const { onAfterScroll, onItemClick, onItemInViewport } = useTracking({
    amsSearch: props.amsSearch,
    amsSliderRef,
})

useItemsIntersectionObserver({
    listRef: toRef(() => amsSliderRef.value?.$el),
    itemsComponents: itemsComponents,
    onItemInViewport,
})
</script>
